import styled from 'styled-components';
// import { Tooltip } from 'react-tooltip';
// import 'react-tooltip/dist/react-tooltip.css';


const cardStyles = {
  Container: styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    background: #fff;
    flex-direction: column;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 5%);
    border: 1px solid #ff754c;
    border-radius: 12px;
    margin-bottom: 10px;
  `,

  Header: styled.div`
    border-bottom: 1px solid #f0f3f6;
    padding: 20px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: flex-start;
    justify-content: space-between;
  `,

  LogoContainer: styled.div`
    width: fit-content;
    margin-right: 10px;
  `,

  Logo: styled.img``,

  RightIcon: styled.img`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  `,

  TextContainer: styled.div`
    flex: 4;
  `,

  Heading: styled.h2`
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #0f0b28;
    position: relative;
  `,

  Subtitle: styled.h5`
    font-size: 10px;
    line-height: 15px;
    text-align: left;
  `,

  Body: styled.section`
    padding: 10px 20px;
    border-bottom: 1px solid #f0f3f6;
  `,

  BorderedBody: styled.section`
    padding: 35px 20px 20px 20px;
    border-radius: 10px;
    position: relative;
    border: 1px solid #f0f3f6;
  `,

  DataRow: styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  `,

  SpaceRow: styled.div`
    height: 10px;
    width: 100%;
  `,

  DataIconContainer: styled.div`
    display: flex;
    padding-top: 2.5px;
    padding-right: 7.5px;
  `,

  DataIcon: styled.img``,

  DataColumn: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
  `,

  DataTextContainer: styled.div`
    display: flex;
    flex-direction: column;
    height: fit-content;
  `,

  DataTextHeading: styled.span`
    font-size: 12px;
    padding: 0;
    line-height: 18px;
    font-weight: 500;
    color: #0f0b28;
    display: flex;
    flex-direction: row;
  `,

  DataTextSubContainer: styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 2px;
    justify-content: space-between;
    width: 100%;
  `,

  DataTextSubtitle: styled.h5`
    font-size: 10px;
    font-weight: 400;
    color: #3f3e3a;
    line-height: 10px;
  `,

  DataTextSubtitleCancel: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,

  DataTextSubtitleCancelText: styled.span`
    font-weight: 500;
    font-size: 10px;
    color: #a5a6bb;
    text-decoration: line-through;
    margin-left: 5px;
  `,

  WarningText: styled.h4`
    font-weight: 600;
    width: 100%;
    padding: 10px 0;
    line-height: 18px;
    letter-spacing: 0.25px;
    text-align: center;
    font-size: 12px;
    border-bottom: 1px solid #f0f3f6;
  `,

  ButtonGroup: styled.div`
    display: flex;
    flex-direction: row;
  `,

  ConfirmButton: styled.button`
    flex: 1;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    padding: 2.5px 0;
    color: #ffbb00;
    padding: 10px 0;
  `,

  ConfirmLink: styled.a`
    flex: 1;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    padding: 2.5px 0;
    color: #ffbb00;
    padding: 10px 0;
    text-align: center;
  `,

  CancelButton: styled.button`
    flex: 1;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    padding: 2.5px 0;
    border-left: 1px solid #f0f3f6;
    color: #f25540;
    padding: 10px 0;
  `,

  PriceContainer: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 0;
  `,

  PriceText: styled.span`
    font-weight: 700;
    font-size: 16px;
    margin-left: 7.5px;
    letter-spacing: 0.25px;
  `,

  UpdateHeading: styled.h1`
    font-size: 12px;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 0 !important;
    line-height: 18px;
    font-weight: 500;
    color: #0f0b28;
    margin-bottom: 10px;
  `,

  UpdateContainer: styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    border: 1px solid #ff754c;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  `,

  UpdateText: styled.span`
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.25px;
    color: #0f0b28;
    border-bottom: 1px solid #f0f3f6;
    padding: 10px;
    padding-top: 7.5px;
  `,

  LightUpdateText: styled.span`
    color: #767787;
  `,

  CopayBox: styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    border-bottom: 1px solid #f0f3f6;
    justify-content: space-between;
    align-items: center;
  `,

  CopayText: styled.h3`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.25px;
  `,

  CopayPriceContainer: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,

  LabelContainer: styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  `,

  LabelText: styled.span`
    font-weight: 500;
    font-size: 12px;
  `,

  // ToolTip: styled(Tooltip)`
  //   &.type-dark.place-top {
  //     background-color: #f4f0ff;
  //     padding: 0.3rem 1rem;
  //     color: #4e4e4e;

  //     &:after {
  //       border-top-color: #f4f0ff;
  //     }
  //   }

  //   &.react-tooltip {
  //     background: #f4f0ff !important;
  //     color: #4e4e4e !important;
  //     width: 80% !important;
  //     white-space: pre-wrap !important;
  //   }
  // `,

  ProfilePicture: styled.img`
    border-radius: 12px;
    height: 40px;
    width: 40px;
  `,

  Footer: styled.div`
    padding: 10px 20px;
  `,

  Hairline: styled.div`
    width: 100%;
    height: 1px;
    background: #f0f3f6;
  `,

  AbsoluteColumn: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0;
    top: 50%;
    min-height: 100%;
    transform: translate(0, -50%);
  `,

  DistanceText: styled.span`
    font-weight: 600;
    font-size: 8px;
    color: #ffbb00;
    letter-spacing: 0.25px;
    text-transform: lowercase;
  `,

  BorderImage: styled.img`
    border: 1px solid #7dcc18;
    height: 30px;
    width: 30px;
    padding: 4px;
    border-radius: 6px;
  `,

  DoctorName: styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #0f0b28;
  `,

  PayButton: styled.button`
    background: #ffbb00;
    border-radius: 12px;
    width: 100%;
    margin-top: 30px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    line-height: 150%;
  `,

  AbsoluteTag: styled.div`
    position: absolute;
    left: 5%;
    top: 0;
    background: #d2f1e0;
    color: #00721f;
    font-size: 10px;
    font-weight: 600;
    padding: 2.5px 5px;
    border-radius: 0 0 5px 5px;
  `,
};

export default cardStyles;
